var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_lock",
    transform: "translate(-0.35 0.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 36,
    height: 36,
    rx: 10,
    transform: "translate(0.35 -0.198)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 36,
    height: 36,
    transform: "translate(0.35 -0.198)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21746",
    "data-name": "Path 21746",
    d: "M146.327,13.5H143.85V10.535a4.935,4.935,0,1,0-9.871,0V13.5h-2.458a.5.5,0,0,0-.484.5v3.445a7.887,7.887,0,1,0,15.773,0V14a.5.5,0,0,0-.483-.5Zm-7.413,6.426a1.481,1.481,0,1,1,1.471-1.491A1.47,1.47,0,0,1,138.914,19.923ZM135.953,13.5V10.535a2.961,2.961,0,0,1,5.923,0V13.5Z",
    transform: "translate(-120.574 2.332)",
    fill: "#8ca6c5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.45821c086dc07ee842e7b95aecee21f5.svg";
export { ForwardRef as ReactComponent };